export const CAROUSEL_IMAGES = [
  {
    img: "./assets/openingScreen/OpeningScreen1.jpg",
    title: "",
    description: "",
  },
  {
    img: "./assets/openingScreen/OpeningScreen2.jpg",
    title: "",
    description: "",
  },
  {
    img: "./assets/openingScreen/OpeningScreen3.jpg",
    title: "",
    description: "",
  },
];
